import { render, staticRenderFns } from "./CompartirShared.vue?vue&type=template&id=3228453d&scoped=true"
import script from "./CompartirShared.vue?vue&type=script&lang=js"
export * from "./CompartirShared.vue?vue&type=script&lang=js"
import style0 from "./CompartirShared.vue?vue&type=style&index=0&id=3228453d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3228453d",
  null
  
)

export default component.exports